import {
  GET_SUPERANNUATION_INFORMATION,
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_ENTITY_INFORMATION,
  GET_COMPARE_SUPERANNUATIONS_INFO,
  GET_ICE_PROJECTION_MODEL,
  GET_ICE_API_RESPONSE,
  GET_SUPERANNUATION_CHART_MODEL,
} from "../../../helpers/vuex-constants";

export default {
  [GET_SUPERANNUATION_INFORMATION](state) {
    return state.superannuationdata;
  },
  [GET_SELECTED_SUPERANNUATION_INFORMATION](state) {
    return state.selectedSuperannuation;
  },
  [GET_SUPERANNUATION_ENTITY_INFORMATION](state) {
    return state.superannuationEntitiesInfo;
  },
  [GET_COMPARE_SUPERANNUATIONS_INFO](state) {
    return state.compareSuperannuations;
  },

  [GET_ICE_PROJECTION_MODEL](state) {
    return state.iceProjectionModel;
  },
  [GET_ICE_API_RESPONSE](state) {
    return state.iceAPIResponse;
  },
  [GET_SUPERANNUATION_CHART_MODEL](state) {
    return state.superChartModel;
  },
};
